import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminVolunteersEventKeys = {
  ADMIN_VOLUNTEER_ADD_BUTTON_CLICK: "admin-volunteer-add-button-click",
  ADMIN_VOLUNTEER_CREATE_PAGE_VIEW: "admin-volunteer-create-page-view",
  ADMIN_VOLUNTEER_DELETE_BUTTON_CLICK: "admin-volunteer-delete-button-click",
  ADMIN_VOLUNTEER_DELETE_FAILURE: "admin-volunteer-delete-failure",
  ADMIN_VOLUNTEER_DETAIL_PAGE_VIEW: "admin-volunteer-detail-page-view",
  ADMIN_VOLUNTEER_EDIT_BUTTON_CLICK: "admin-volunteer-edit-button-click",
  ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_ATTEMPT:
    "admin-volunteer-edit-form-submit-attempt",
  ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_FAILURE:
    "admin-volunteer-edit-form-submit-failure",
  ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_SUCCESS:
    "admin-volunteer-edit-form-submit-success",
  ADMIN_VOLUNTEER_EDIT_PAGE_VIEW: "admin-volunteer-edit-page-view",
  ADMIN_VOLUNTEER_EXPORT_CSV_CLICK: "admin-volunteer-export-csv-click",
  ADMIN_VOLUNTEER_EXPORT_CSV_FAILURE: "admin-volunteer-export-csv-failure",
  ADMIN_VOLUNTEER_EXPORT_CSV_SUCCESS: "admin-volunteer-export-csv-success",

  ADMIN_VOLUNTEER_FORM_SUBMIT_ATTEMPT: "admin-volunteer-form-submit-attempt",

  ADMIN_VOLUNTEER_FORM_SUBMIT_FAILURE: "admin-volunteer-form-submit-failure",

  ADMIN_VOLUNTEER_FORM_SUBMIT_SUCCESS: "admin-volunteer-form-submit-success",

  // New import-related events
  ADMIN_VOLUNTEER_IMPORT_BUTTON_CLICK: "admin-volunteer-import-button-click",
  ADMIN_VOLUNTEER_IMPORT_FAILURE: "admin-volunteer-import-failure",
  ADMIN_VOLUNTEER_IMPORT_SUCCESS: "admin-volunteer-import-success",

  ADMIN_VOLUNTEER_STATUS_TOGGLE_ATTEMPT:
    "admin-volunteer-status-toggle-attempt",

  ADMIN_VOLUNTEER_STATUS_TOGGLE_FAILURE:
    "admin-volunteer-status-toggle-failure",

  ADMIN_VOLUNTEER_STATUS_TOGGLE_SUCCESS:
    "admin-volunteer-status-toggle-success",

  ADMIN_VOLUNTEER_TABLE_FILTER_AREAS: "admin-volunteer-filter-areas",

  ADMIN_VOLUNTEER_TABLE_FILTER_CLAIMED_NEEDS:
    "admin-volunteer-filter-claimed-needs",

  ADMIN_VOLUNTEER_TABLE_FILTER_CREATED_AT: "admin-volunteer-filter-created-at",

  ADMIN_VOLUNTEER_TABLE_FILTER_EMAIL: "admin-volunteer-filter-email",

  ADMIN_VOLUNTEER_TABLE_FILTER_FREQUENCY: "admin-volunteer-filter-frequency",

  ADMIN_VOLUNTEER_TABLE_FILTER_NAME: "admin-volunteer-filter-name",

  ADMIN_VOLUNTEER_TABLE_FILTER_STATUS: "admin-volunteer-filter-status",

  ADMIN_VOLUNTEER_TABLE_FILTER_SUBSCRIBED: "admin-volunteer-filter-subscribed",

  ADMIN_VOLUNTEER_TABLE_SEARCH: "admin-volunteer-search",
  ADMIN_VOLUNTEER_VIEW_BUTTON_CLICK: "admin-volunteer-view-button-click",
  ADMIN_VOLUNTEERS_PAGE_VIEW: "admin-volunteers-page-view",
} as const;

export const AdminVolunteersEventCatalog: EventCatalogFromKeys<
  typeof AdminVolunteersEventKeys
> = {
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_ADD_BUTTON_CLICK]: {
    description:
      "Admin clicked the add volunteer button to open the new volunteer form",
    eventType: EventType.BUTTON_CLICK,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_ADD_BUTTON_CLICK,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_CREATE_PAGE_VIEW]: {
    description: "Admin viewed the create volunteer page",
    eventType: EventType.PAGE_VIEW,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_CREATE_PAGE_VIEW,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_DELETE_BUTTON_CLICK]: {
    description: "Admin clicked the delete button for a volunteer",
    eventType: EventType.BUTTON_CLICK,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_DELETE_BUTTON_CLICK,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_DELETE_FAILURE]: {
    description: "Admin failed to delete a volunteer",
    eventType: EventType.ERROR,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_DELETE_FAILURE,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_DETAIL_PAGE_VIEW]: {
    description: "Admin viewed the volunteer detail page",
    eventType: EventType.PAGE_VIEW,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_DETAIL_PAGE_VIEW,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_BUTTON_CLICK]: {
    description: "Admin clicked the edit button for a volunteer",
    eventType: EventType.BUTTON_CLICK,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_BUTTON_CLICK,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the edit volunteer form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_ATTEMPT,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_FAILURE]: {
    description:
      "Admin failed to submit the edit volunteer form (validation or server error)",
    eventType: EventType.ERROR,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_FAILURE,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the edit volunteer form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_FORM_SUBMIT_SUCCESS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_PAGE_VIEW]: {
    description: "Admin viewed the edit volunteer page",
    eventType: EventType.PAGE_VIEW,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EDIT_PAGE_VIEW,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_AREAS]: {
    description: "Admin filtered volunteers by areas",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_AREAS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_FREQUENCY]: {
    description: "Admin filtered volunteers by frequency",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_FREQUENCY,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_STATUS]: {
    description: "Admin filtered volunteers by status",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_STATUS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_SUBSCRIBED]: {
    description: "Admin filtered volunteers by subscription status",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_SUBSCRIBED,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the new volunteer form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_FORM_SUBMIT_ATTEMPT,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_FORM_SUBMIT_FAILURE]: {
    description:
      "Admin failed to submit the new volunteer form (validation or server error)",
    eventType: EventType.ERROR,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_FORM_SUBMIT_FAILURE,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the new volunteer form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_FORM_SUBMIT_SUCCESS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_SEARCH]: {
    description: "Admin searched for a specific volunteer",
    eventType: EventType.FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_SEARCH,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_STATUS_TOGGLE_ATTEMPT]: {
    description: "Admin attempted to toggle the status of a volunteer",
    eventType: EventType.INTERACTION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_STATUS_TOGGLE_ATTEMPT,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_STATUS_TOGGLE_FAILURE]: {
    description: "Admin failed to toggle the status of a volunteer",
    eventType: EventType.ERROR,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_STATUS_TOGGLE_FAILURE,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_STATUS_TOGGLE_SUCCESS]: {
    description: "Admin successfully toggled the status of a volunteer",
    eventType: EventType.INTERACTION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_STATUS_TOGGLE_SUCCESS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_VIEW_BUTTON_CLICK]: {
    description: "Admin clicked the view button for a volunteer",
    eventType: EventType.BUTTON_CLICK,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_VIEW_BUTTON_CLICK,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEERS_PAGE_VIEW]: {
    description: "Admin viewed the volunteers management page",
    eventType: EventType.PAGE_VIEW,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEERS_PAGE_VIEW,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_CLAIMED_NEEDS]: {
    description: "Admin filtered volunteers by claimed needs",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_CLAIMED_NEEDS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_CREATED_AT]: {
    description: "Admin filtered volunteers by created at",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_CREATED_AT,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_EMAIL]: {
    description: "Admin filtered volunteers by email",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_EMAIL,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_NAME]: {
    description: "Admin filtered volunteers by name",
    eventType: EventType.TABLE_FILTER,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_TABLE_FILTER_NAME,
  },
  // New import events
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_IMPORT_BUTTON_CLICK]: {
    description: "Admin clicked the import volunteers button",
    eventType: EventType.BUTTON_CLICK,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_IMPORT_BUTTON_CLICK,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_IMPORT_SUCCESS]: {
    description: "Admin successfully imported volunteers from CSV",
    eventType: EventType.INTERACTION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_IMPORT_SUCCESS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_IMPORT_FAILURE]: {
    description: "Admin failed to import volunteers from CSV",
    eventType: EventType.ERROR,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_IMPORT_FAILURE,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EXPORT_CSV_CLICK]: {
    description: "Admin clicked export CSV for volunteers",
    eventType: EventType.BUTTON_CLICK,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EXPORT_CSV_CLICK,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EXPORT_CSV_SUCCESS]: {
    description: "Admin successfully exported volunteers as CSV",
    eventType: EventType.INTERACTION,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EXPORT_CSV_SUCCESS,
  },
  [AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EXPORT_CSV_FAILURE]: {
    description: "Admin failed to export volunteers as CSV",
    eventType: EventType.ERROR,
    id: AdminVolunteersEventKeys.ADMIN_VOLUNTEER_EXPORT_CSV_FAILURE,
  },
};
